import React, { useState } from "react";

import valueContext from "./useContext";

function ContextProvider(props) {
  const [memberCore, setMemberCore] = useState(1);
  const splitToken = text => {
    const textA = text.split(".")[0];
    const textB = text.split(".")[1];
    const textC = text.split(".")[2];
    return { textA, textB, textC };
  };

  const crypt = (salt, text) => {
    const textToChars = text => text.split("").map(c => c.charCodeAt(0));

    const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);

    return text
      .split("")
      .map(textToChars)
      .map(applySaltToChar)
      .map(byteHex)
      .join("");
  };

  const decrypt = (salt, encoded) => {
    const textToChars = text => text.split("").map(c => c.charCodeAt(0));
    const applySaltToChar = code =>
      textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded
      .match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join("");
  };

  const joinToken = () => {
    const tokenA = window.localStorage.getItem("_A");
    const tokenB = window.localStorage.getItem("_B");
    const tokenC = window.localStorage.getItem("_C");
    if (tokenA && tokenB && tokenC) {
      const A = decrypt("salt", tokenA);
      const B = decrypt("salt", tokenB);
      const C = decrypt("salt", tokenC);
      const text = A.concat(".", B);
      return text.concat(".", C);
    } else {
      return null;
    }
  };
  const joinMemberToken = () => {
    const tokenA = window.localStorage.getItem("A_");
    const tokenB = window.localStorage.getItem("B_");
    const tokenC = window.localStorage.getItem("C_");
    if (tokenA && tokenB && tokenC) {
      const A = decrypt("salt", tokenA);
      const B = decrypt("salt", tokenB);
      const C = decrypt("salt", tokenC);
      const text = A.concat(".", B);
      return text.concat(".", C);
    } else {
      return null;
    }
  };

  return (
    <valueContext.Provider
      value={{
        crypt,
        decrypt,
        splitToken,
        joinToken,
        joinMemberToken,
        memberCore,
        setMemberCore
      }}
    >
      {props.children}
    </valueContext.Provider>
  );
}

export default ContextProvider;
